import { NumbersListSection } from './NumbersListSection/NumbersList.section';

import { ThemeProvider } from '@aircall/tractor-v2';

export function NumbersPage() {
  return (
    <ThemeProvider>
      <NumbersListSection />
    </ThemeProvider>
  );
}
